import { object, string, null as zNull } from "zod";

export const setRivoIntegration = {
  name: "setRivoIntegration" as const,
  input: object({
    apiKey: string().nullish(),
    rewardsPageUrl: string().nullish(),
  }),
  output: zNull(),
};
